import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import { Col, Container, Row, Button, Spinner, OverlayTrigger, Popover } from 'react-bootstrap';
import ChemComponent from '../ChemComponent';
import { withRouter } from '../withRouter';
import ChemEdit from '../ChemEdit';
import QueryTable from '../QueryTable';
import HashLink from '../HashLink';
import { PlusSquare, PencilSquare } from 'react-bootstrap-icons';

class Schedules extends ChemComponent {
	constructor(props) {
		super(props);

		var search = {
			CAL_YEAR: [],
			SEMESTER: [],
			COURSE_NAME: '',
			FACULTY: '',
			GSI: ''
		};
		
		var initScheduleList = this.copyTable(scheduleList);
		if (typeof(Storage) !== 'undefined') {
			var storedSearch = localStorage.getItem('GradOffice_Schedules_search');
			if (storedSearch) {
				storedSearch = JSON.parse(storedSearch);
				this.mergeObject(search, storedSearch);
				search = storedSearch;
				initScheduleList.query.search = this.constructSearch(search);
			}
		}

		this.state = {
			scheduleList: initScheduleList,
			search: search,
			searchCount: null,
			renderKey: 0
		};
	}
	
	onChangeSearch(accessor, value) {
		var search = this.copyObject(this.state.search);
		this.setByAccessor(search, accessor, value);
		this.mergeState({ search: search });
	}

	onSubmitSearch(event) {
		var newScheduleList = this.copyTable(scheduleList);
		newScheduleList.query.search = this.constructSearch(this.state.search);
		this.mergeState({ 
			scheduleList: newScheduleList,
			searchCount: null,
			renderKey: this.state.renderKey + 1
		});
		if (typeof(Storage) !== 'undefined') {
			localStorage.setItem('GradOffice_Schedules_search', JSON.stringify(this.state.search));
		}
		if (event && event.nativeEvent && event.nativeEvent.submitter) event.nativeEvent.submitter.blur();
	}
	
	constructSearch(data) {
		// construct search terms
		var i;
		var search = {
			Operator: 'and',
			Children: []
		};
		
		if (Array.isArray(data.CAL_YEAR) && data.CAL_YEAR.length > 0) {
			var yearSearch = { Operator: 'or', Children: [] };
			for (i = 0; i < data.CAL_YEAR.length; i++) {
				yearSearch.Children.push({ Attribute: 'CAL_YEAR', Operator: '=', StringValue: data.CAL_YEAR[i] });
			}
			search.Children.push(yearSearch);
		}
		if (Array.isArray(data.SEMESTER) && data.SEMESTER.length > 0) {
			var semesterSearch = { Operator: 'or', Children: [] };
			for (i = 0; i < data.SEMESTER.length; i++) {
				var caseCombos = data.SEMESTER[i] === 'SP' ? ['sp','Sp','sP','SP'] :
					(data.SEMESTER[i] === 'FA' ? ['fa', 'Fa', 'fA', 'FA'] : ['su','Su','sU','SU']);
				for (var c = 0; c < caseCombos.length; c++) {
					semesterSearch.Children.push({ Attribute: 'SEMESTER', Operator: 'like', StringValue: '%' + caseCombos[c] + '%' });
				}
			}
			search.Children.push(semesterSearch);
		}
		if (!this.isEmpty(data.COURSE_NAME)) search.Children.push({ Attribute: 'COURSE_NAME', Operator: '=', StringValue: data.COURSE_NAME });
		if (!this.isEmpty(data.FACULTY)) search.Children.push({ Operator: 'or', Children: [
			{ Attribute: 'FACULTY1', Operator: 'like', StringValue: '%' + data.FACULTY + '%' },
			{ Attribute: 'FACULTY2', Operator: 'like', StringValue: '%' + data.FACULTY + '%' },
			{ Attribute: 'OTHER_FACULTY', Operator: 'like', StringValue: '%' + data.FACULTY + '%' }
		]});
		if (!this.isEmpty(data.GSI)) search.Children.push({ Attribute: 'GSI_LIST', operator: 'like', StringValue: '%' + data.GSI + '%' });

		// if there are no terms, forget it
		if (search.Children.length === 0) search = null;
		return search;
	}

	addSchedule() {
		this.props.navigate('/GradOffice/Schedules/new');
	}
	
	editSchedule(scheduleId) {
		this.props.setScheduleEditable(true);
		this.props.navigate('/GradOffice/Schedules/' + scheduleId);		
	}

	viewSchedule(scheduleId) {
		this.props.setScheduleEditable(false);
		this.props.navigate('/GradOffice/Schedules/' + scheduleId);		
	}
	
	onSearchResult(data) {
		this.mergeState({
			searchCount: data.ResultCount
		});
	}

	render() {
		
		var exportData = this.createHiddenFormData({
			__RequestVerificationToken: this.props.user.antiForgeryToken,
			title: 'Schedules',
			columns: exportColumns,
			entity: 'ADMISSIONS.SCHEDULES_VW',
			search: this.constructSearch(this.state.search),
			order: ['HAS_YEAR desc','CAL_YEAR desc','SEMESTER','COURSE_NAME']
		});
		
		return (<>
			<Container fluid>
			  <Row>
			    <Col style={{ paddingTop: '20px', marginBottom: '20px', border: '1px solid #ccc', borderRadius: 6, backgroundColor: '#FEFEFE' }}>
				  <Container fluid>	
					<Row>
					  <Col xs={12}>
						<span style={{ fontSize: '18px', fontWeight: 'bold' }}>Schedules</span>
						<ChemEdit parent={this} columns={scheduleSearch} data={this.state.search} renderKey={this.state.renderKey} 
						  onChange={(accessor, value) => this.onChangeSearch(accessor, value)} {...this.props} />
					  </Col>
					</Row>
					<Form.Group as={Row} style={{ borderTop: '1px solid #eee', paddingTop: 10, marginBottom: 10 }}>
					  <Col xs={3} style={{ marginTop: 8}}>
						{this.isEmpty(this.state.searchCount) ? <Spinner animation='border' as='div' size='sm' style={{ marginRight: '4px' }} /> : this.state.searchCount} records found.
					  </Col>
					  <Col xs={1} style={{ marginTop: 6}}>
						<form action={this.getConfig().host + '/Home/Excel'} method='POST'>
							{exportData.map((excelFormField, index) => {
								return (<input key={index} type='hidden' name={excelFormField.name} value={excelFormField.value} />);
							})}
							<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to Excel</Popover.Header></Popover>}>
							  <input type='image' src={this.getConfig().host + '/Content/Icons/Excel.png'} style={{ paddingLeft: '20px' }} alt="Export to Excel" />
							</OverlayTrigger>
						</form>
					  </Col>
					  <Col xs={1} style={{ marginTop: 6}}>
						<form action={this.getConfig().host + '/Home/Pdf'} method='POST'>
							{exportData.map((pdfFormField, index) => {
								return (<input key={index} type='hidden' name={pdfFormField.name} value={pdfFormField.value} />);
							})}
							<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to PDF</Popover.Header></Popover>}>
							  <input type='image' src={this.getConfig().host + '/Content/Icons/Pdf.png'} style={{ paddingLeft: '20px' }} alt="Export to PDF" />
							</OverlayTrigger>
						</form>
					  </Col>
					  <Col xs={7}>
						<Button id="update" variant="warning" type="button" className="float-end" onClick={(event) => this.onSubmitSearch(event)}>Search</Button>
					  </Col>
					</Form.Group>
				  </Container>
				</Col>
			  </Row>
			  <Row>
				<Col>
				  <QueryTable renderKey={this.state.renderKey} parent={this} name='GradOffice_Schedules' table={this.state.scheduleList}
				    onResult={(data) => this.onSearchResult(data)} offsetHeight='300px' />
				</Col>
			  </Row>
			</Container>
		</>);		
	}
}

const scheduleSearch = [
	{ Header: 'Semester', accessor: 'SEMESTER', type: 'list', row: 0, col: 0,
		options: [{ value: 'FA', label: 'Fall' },{ value: 'SP', label: 'Spring' },{ value: 'SU', label: 'Summer' }]},
	{ Header: 'Year', accessor: 'CAL_YEAR', type: 'list', row: 0, col: 1,
		options: { value: 'CAL_YEAR', label: 'CAL_YEAR', entity: 'ADMISSIONS.COURSE_SCHEDULE', distinct: true, order: 'CAL_YEAR desc',
			search: { Operator: 'and', Children: [
				{ Attribute: 'DELETE_FLAG', Operator: 'is not null' },
				{ Attribute: 'CAL_YEAR', Operator: 'is not null' }]}}},
	{ Header: 'Course', accessor: 'COURSE_NAME', row: 0, col: 2 },
	{ Header: 'Faculty', accessor: 'FACULTY', row: 1, col: 0 },
	{ Header: 'GSI', accessor: 'GSI', row: 1, col: 1 }
];

const scheduleList = {
	query: { entity: 'ADMISSIONS.SCHEDULES_VW', search: null, order: ['HAS_YEAR desc','CAL_YEAR desc','SEMESTER','COURSE_NAME'] },
	pageSize: 20,
	columns: [
		{ Header: props => <PlusSquare style={{ cursor: 'pointer' }} onClick={() => props.parent.addSchedule()} />, accessor: 'id', 
			Cell: props => <PencilSquare style={{ cursor: 'pointer' }} onClick={() => props.parent.editSchedule(props.row.values.SCHEDULE_ID)} />, width: 25 },
		{ Header: 'ID', accessor: 'SCHEDULE_ID', Cell: props => <HashLink onClick={() => props.parent.viewSchedule(props.row.values.SCHEDULE_ID)}>{props.value}</HashLink> },
		{ Header: 'Course', accessor: 'COURSE_NAME' },
		{ Header: 'Semester', accessor: 'SEMESTER' },
		{ Header: 'Year', accessor: 'CAL_YEAR' },
		{ Header: 'Instructor 1', accessor: 'FACULTY1' },
		{ Header: 'Instructor 2', accessor: 'FACULTY2' },
		{ Header: 'Outside Instructor', accessor: 'OTHER_FACULTY' },
		{ Header: 'Module', accessor: 'MODULE' },
		{ Header: 'GSI', accessor: 'GSI_LIST', Cell: props => props.parent.getCellFragment(props.value) }
	]
};

const exportColumns = [
	{ Header: 'ID', accessor: 'SCHEDULE_ID', width: 25 },
	{ Header: 'Course', accessor: 'COURSE_NAME', width: 25 },
	{ Header: 'Semester', accessor: 'SEMESTER', width: 25 },
	{ Header: 'Year', accessor: 'CAL_YEAR', width: 25 },
	{ Header: 'Instructor 1', accessor: 'FACULTY1', width: 25 },
	{ Header: 'Instructor 2', accessor: 'FACULTY2', width: 25 },
	{ Header: 'Outside Instructor', accessor: 'OTHER_FACULTY', width: 25 },
	{ Header: 'Module', accessor: 'MODULE', width: 25 },
	{ Header: 'GSI', accessor: 'GSI_LIST', width: 25, wraptext: true }
];

export default withRouter(Schedules);
